var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-loading',{staticClass:"loading",attrs:{"color":"#1989fa","vertical":""}},[_vm._v(" "+_vm._s(_vm.message || "文档加载中...")+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }